import React from "react";
import { Button, Spinner, Form, Container, Row, Col } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import { fetchPlaylists } from "./services/DataService";
import "./style/volunteer.scss";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

class Playlists extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      filtered: [],
    };
    this.playlists = [];
    this.onSearchChange = this.onSearchChange.bind(this);
    this.timeout = null;
  }

  componentDidMount() {
    fetchPlaylists().then((playlists) => {
      if (!playlists) {
        playlists = [];
      }
      this.playlists = playlists;
      this.setState({ filtered: playlists, loading: false });
    });
  }

  onSearchChange(event) {
    let search = event.target.value;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      let filtered = this.playlists;
      if (search !== "") {
        let terms = search.toLowerCase().split(" ");
        terms.map((term) => {
          return (filtered = filtered.filter((item) =>
            `${item.name.toLowerCase()}`.includes(term)
          ));
        });
      }
      this.setState({
        filtered: filtered,
      });
    }, 800);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" className="kugs-spinner">
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        this.setState({ redirect: `/playlists/${row.id}` });
      },
      onMouseEnter: (e, row, rowIndex) => {
        e.target.parentNode.className = "row-enter";
      },
      onMouseLeave: (e, row, rowIndex) => {
        e.target.parentNode.className = "row-leave";
      },
    };

    return (
      <Container fluid>
        <Row>
          <Col md="3">
            <div className="count">{this.state.filtered.length} Playlists</div>
          </Col>
          <Col md="6">
            <div className="search-icon glyphicon glyphicon-search"></div>
            <Form.Control
              type="text"
              className="search-box"
              onChange={this.onSearchChange}
            />
          </Col>
          <Col md="3">
            <Button
              variant="primary"
              href="/playlists/add"
              className="glyphicon glyphicon-plus btn-add"
            >
              <div className="hidden">Add</div>
            </Button>
          </Col>
        </Row>
        <BootstrapTable
          keyField="id"
          data={this.state.filtered}
          rowEvents={rowEvents}
          columns={[
            {
              dataField: "name",
              text: "Name",
            },
            {
              dataField: "created_by",
              text: "Author",
              headerStyle: (column, colIndex) => {
                return { width: "24%" };
              },
            },
            {
              dataField: "date_created",
              text: "Date Created",
              headerStyle: (column, colIndex) => {
                return { width: "18%" };
              },
            },
          ]}
        />
      </Container>
    );
  }
}

export default Playlists;
